import React, { useState, useEffect } from 'react'
import styles from './Header.module.scss'
import Logo from '../../../../assets/img/meituanLogo.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createMerchantI18n } from '@/utils/i18n'
import travelDownload from '@assets/img/travelDownload.png'
import { isProd } from '@/utils/utils'
import SimpleLanguageSelector from '@common/components/SimpleLanguageSelector'
import { merchantLanguageOptions } from '@/config'


interface HeaderProps {
  onJoin: () => void
}

const Header: React.FC<HeaderProps & WithI18nProps> = ({ onJoin, i18n }) => {
  const t = React.useMemo(() => createMerchantI18n(i18n), [i18n])
  const [selectedRegion, setSelectedRegion] = useState('')

  useEffect(() => {
    const currentLanguage = getCurrentLanguage()
    setSelectedRegion(currentLanguage)
  }, [i18n]) // eslint-disable-line react-hooks/exhaustive-deps

  const getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const handleLanguageChange = (lang: string) => {
    setSelectedRegion(lang)
    i18n.changeLanguage(lang)
  }
  const goHome = () => {
    window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/merchantPc.html' : 'https://osm.51ping.com/os/h5/seek-investment/merchantPc.html'
  }

  const openLoginBackend = () => {
    // 区分当前的语言种类
    window.location.href = isProd() ? `https://eo.dianping.com/login/index.html?lang=${selectedRegion}` : `https://eo.51ping.com/login/index.html?lang=${selectedRegion}`
  }

  const openAgentJoin = () => {
    window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/agentPc.html' : 'https://osm.51ping.com/os/h5/seek-investment/agentPc.html'
  }

  return (
    <header className={`${styles.header} ${ selectedRegion !== 'zh-CN' ? styles.enHeader : ''}`}>
      <div className={styles.headerContainer}>
        <div className={styles.headerLeft} onClick={goHome}>
          <div className={styles.logoArea}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <span className={`${styles.title} ${ selectedRegion !== 'zh-CN' ? styles.enTitle : ''}`}>{t('logoTitle', "美团境外商家")}</span>
          </div>
        </div>

        <div className={styles.headerRight}>
          <div className={styles.navLinks}>
            <div
              className={`${styles.navLink} ${ selectedRegion !== 'zh-CN' ? styles.enNavLink : ''}`}
              onClick={openAgentJoin}
            >
              {t('agentJoin', "代理商入驻")}
            </div>
            <div
              className={`${styles.navLink} ${ selectedRegion !== 'zh-CN' ? styles.enNavLink : ''}`}
              onClick={() => window.open('https://www.dianping.com/overseas/openplatform/mt/main', '_blank')}
            >
              {t('openPlatform', "开放平台")}
            </div>
            <div className={`${styles.navLink} ${ selectedRegion !== 'zh-CN' ? styles.enNavLink : ''}`}>
            <span>{t('downloadMeituanOverseasApp', "美团境外商家app")}</span>
            <div className={styles.qrDropdown}>
              <div className={styles.qrBox}>
                <img src={travelDownload} alt="QR" />
                  <p>{t('downloadMeituanOverseasApp', "美团境外商家app")}</p>
              </div>
            </div>
          </div>
          </div>
          

          <div className={`${styles.joinBtn} ${ selectedRegion !== 'zh-CN' ? styles.enJoinBtn : ''}`} onClick={onJoin}>
            {t('wantToJoin', "我要入驻")}
          </div>
          <div
            className={`${styles.loginBtn} ${ selectedRegion !== 'zh-CN' ? styles.enLoginBtn : ''}`}
            onClick={openLoginBackend}
          >
            {t('loginBackend', "登录商家后台")}
          </div>
          <SimpleLanguageSelector
            selectedLanguage={selectedRegion}
            onLanguageChange={handleLanguageChange}
            className={styles.topLink}
            options={merchantLanguageOptions}
          />

          {/* 复杂的地区语言选择器（备用）
          <RegionLanguageSelector
            selectedLanguage={selectedRegion}
            onLanguageChange={(country, lang) => handleLanguageChange(lang)}
            i18n={i18n}
            className={styles.topLink}
          />
          */}
        </div>
      </div>
    </header>
  )
}

export default withTranslator(Header)
